import React, { useState } from "react";
import Chart from "react-apexcharts";

const OverviewChart = () => {
  // Defualt chart states
  const [options, setOptions] = useState({
    chart: {
      id: "overview-bar-chart",
    },
    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#17ead9"],
    fill: {
      type: "gradient",
      gradient: {
        type: "vertical",
        shadeIntensity: 0.5,
        inverseColors: false,
        gradientToColors: ["#17e0cb"],
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    states: {
      hover: {
        filter: {
          type: "darken",
          value: 0.85,
        },
      },
    }
  });
  const [series, setSeries] = useState([
    { 
      name: "Raised",
      data: [565, 745, 650, 350, 735, 1475, 720, 1320, 1565, 1420, 1150, 2590],
    },
  ]);

  // Toggle Chart Settings
  const [active, setActive] = useState("year");
  let chartItem = "home__charts__list-items__item";
  const handleClick = (item) => {
    setActive(item);
    switch (item) {
      case "today":
        setOptions({...options, xaxis: { categories: ["1am", "2am", "3am", "4am", "5am", "6am", "7am", "8am", "9am", "10am", "11am", "12am", "1pm", "2pm", "3pm", "4pm", "5pm", "6pm", "7pm", "8pm", "9pm", "10pm", "11pm", "12pm"] }})
        setSeries([ {data: [0, 0, 0, 0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 10, 0, 5, 10, 15, 25, 10, 0 ,0 ,0 ,0]} ]);
        break;
      case "week":
        setOptions({...options, xaxis: { categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] }})
        setSeries([ {data: [10, 5, 25, 60, 85, 150, 130]} ]);
        break;
      case "month":
        setOptions({...options, xaxis: { categories: ["1st", "2nd", "3rd", "4th", "5th", "6th", "7th", "8th", "9th", "10th", "11th", "12th", "13th", "14th", "15th", "16th", "17th", "18th", "19th", "20th", "21st", "22nd", "23rd", "24th", "25th", "26th", "27th", "28th", "29th", "30th", "31st"] }})
        setSeries([ {data: [25, 0, 0, 0, 55, 45, 0, 0, 0, 120, 250, 0, 0, 10, 0, 0, 0, 0, 225, 0, 0, 0, 0, 40, 35, 0, 0, 15, 0, 0, 0]} ]);
        break;
      case "year":
        setOptions({...options, xaxis: { categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"] }})
        setSeries([ {data: [565, 745, 650, 350, 735, 1475, 720, 1320, 1565, 1420, 1150, 2590]} ]);
        break;
      default:
      // do nothing right now.
    }
  };

  return (
    <div className="home__charts__box">
      <div className="home__charts__options">
        <p className="home__charts__title">Overview</p>
        <ul className="home__charts__list-items">
          <li
            onClick={(e) => {
              handleClick("today");
            }}
            className={
              active === "today"
                ? `${chartItem} ${chartItem}--active`
                : `${chartItem}`
            }
          >
            Today
          </li>
          <li
            onClick={(e) => {
              handleClick("week");
            }}
            className={
              active === "week"
                ? `${chartItem} ${chartItem}--active`
                : `${chartItem}`
            }
          >
            Week
          </li>
          <li
            onClick={(e) => {
              handleClick("month");
            }}
            className={
              active === "month"
                ? `${chartItem} ${chartItem}--active`
                : `${chartItem}`
            }
          >
            Month
          </li>
          <li
            onClick={(e) => {
              handleClick("year");
            }}
            className={
              active === "year"
                ? `${chartItem} ${chartItem}--active`
                : `${chartItem}`
            }
          >
            Year
          </li>
        </ul>
      </div>
      <Chart
        className="home__charts__chart"
        options={options}
        series={series}
        type="bar"
        width="100%"
        height="325"
      />
    </div>
  );
};

export default OverviewChart;
